var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLibraryPuzzle = function SvgLibraryPuzzle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "library_puzzle_svg2__a",
    x1: 40.4,
    x2: 185.4,
    y1: 153.4,
    y2: 20.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#library_puzzle_svg2__a",
    id: "library_puzzle_svg2__b",
    x1: 44.4,
    x2: 189.4,
    y1: 157.8,
    y2: 24.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#library_puzzle_svg2__a",
    id: "library_puzzle_svg2__c",
    x1: 8.3,
    x2: 153.3,
    y1: 118.4,
    y2: -14.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#library_puzzle_svg2__a",
    id: "library_puzzle_svg2__d",
    x1: 77.4,
    x2: 222.4,
    y1: 193.8,
    y2: 60.8
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M197.9 68.1 179.8 5.8c-1.2-4.2-5.7-6.7-9.9-5.5L108.8 18c-2.1.6-3.2 2.8-2.7 4.8l5.8 20.2c.4 1.5 2.1 2.2 3.5 1.6 1-.4 1.9-.9 2.9-1.5l3.9-2.4c7.1-4.3 16.3-.7 18.6 7.2s-3.6 15.9-11.8 16h-4.6c-1.1.1-2.2.2-3.2.4-1.5.2-2.5 1.8-2.1 3.2l6.2 21.5c.4 1.4 1.8 2.1 3.2 1.7l21.5-6.2c1.5-.4 3 .5 3.2 2.1.2 1.1.3 2.1.3 3.2v4.6c.2 8.3 8.2 14.1 16.1 11.8s11.5-11.5 7.2-18.6l-2.4-3.9c-.6-.9-1.1-1.9-1.5-2.9-.6-1.4.1-3.1 1.6-3.5l21.5-6.2c1.4-.4 2.1-1.8 1.7-3.2Z",
    style: {
      fill: "url(#library_puzzle_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6 200h-70c-5.8 0-10.5-4.7-10.5-10.5v-70h27.4c-.1-1-.3-1.9-.5-2.9l-1.2-4.5c-1.2-4.6-.3-9.3 2.6-13.1s7.2-5.9 12-5.9 9.1 2.2 12 5.9c2.9 3.8 3.8 8.5 2.6 13.1l-1.2 4.5c-.3.9-.4 1.9-.6 2.8h27.5v27.5c0 1.5-.6 2.9-1.7 3.8-1.1 1-2.6 1.4-4 1.2-1.2-.1-2.4-.4-3.5-.7L69 150c-3-.8-6.2-.2-8.7 1.7s-3.9 4.8-3.9 7.9 1.4 6 3.9 7.9 5.7 2.5 8.7 1.7l4.5-1.2c1.2-.3 2.3-.5 3.5-.7 1.4-.2 2.9.3 4 1.2 1.1 1 1.7 2.4 1.7 3.8v27.4ZM7.1 124.5v64.9c0 3 2.4 5.5 5.5 5.5h64.9v-22.4c-1 .1-1.9.3-2.9.5l-4.5 1.2c-4.6 1.2-9.3.3-13.1-2.6s-5.9-7.2-5.9-12 2.2-9.1 5.9-12c3.8-2.9 8.5-3.8 13.1-2.6l4.5 1.2c.9.2 1.9.4 2.8.6v-22.4H55.1c-1.5 0-2.9-.6-3.8-1.7-1-1.1-1.4-2.6-1.2-4 .1-1.2.4-2.4.7-3.5l1.2-4.5c.8-3 .2-6.2-1.7-8.7-3.8-5-12.1-5-15.9 0-1.9 2.5-2.5 5.7-1.7 8.7l1.2 4.5c.3 1.2.5 2.3.7 3.5.2 1.5-.3 2.9-1.2 4-1 1.1-2.4 1.7-3.8 1.7H7.1Z",
    style: {
      strokeWidth: 0,
      fill: "url(#library_puzzle_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6 124.5H55.2c-1.5 0-2.9-.6-3.8-1.7-1-1.1-1.4-2.6-1.2-4 .1-1.2.4-2.4.7-3.5l1.2-4.5c.8-3 .2-6.2-1.7-8.7-3.8-5-12.1-5-15.9 0-1.9 2.5-2.5 5.7-1.7 8.7l1.2 4.5c.3 1.2.5 2.3.7 3.5.2 1.5-.3 2.9-1.2 4-1 1.1-2.4 1.7-3.8 1.7H2v-70C2 48.7 6.7 44 12.5 44h22.8v5.1H12.6c-3 0-5.5 2.4-5.5 5.5v64.9h22.4c-.1-1-.3-1.9-.5-2.9l-1.2-4.5c-1.2-4.6-.3-9.3 2.6-13.1s7.2-5.9 12-5.9 9.1 2.2 12 5.9c2.9 3.8 3.8 8.5 2.6 13.1l-1.2 4.5c-.3.9-.4 1.9-.6 2.8h22.4V97.1c0-1.5.6-2.9 1.7-3.8 1.1-1 2.6-1.4 4-1.2 1.2.1 2.4.4 3.5.7l4.5 1.2c3 .8 6.2.2 8.7-1.7s3.9-4.8 3.9-7.9-1.4-6-3.9-7.9-5.7-2.5-8.7-1.7L86.8 76c-1.2.3-2.3.5-3.5.7-1.4.2-2.9-.3-4-1.2-1.1-1-1.7-2.4-1.7-3.8v-21c0-.7-.6-1.3-1.3-1.3H49.4v-5.1h26.9c3.5 0 6.4 2.9 6.4 6.4v21c1-.1 1.9-.3 2.9-.5l4.5-1.2c4.6-1.2 9.3-.3 13.1 2.6s5.9 7.2 5.9 12-2.2 9.1-5.9 12c-3.8 2.9-8.6 3.8-13.1 2.6L85.6 98c-.9-.2-1.9-.4-2.8-.6v27.5Z",
    style: {
      strokeWidth: 0,
      fill: "url(#library_puzzle_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.5 200h-70v-27.4c-1 .1-1.9.3-2.9.5l-4.5 1.2c-4.6 1.2-9.3.3-13.1-2.6s-5.9-7.2-5.9-12 2.2-9.1 5.9-12c3.8-2.9 8.5-3.8 13.1-2.6l4.5 1.2c.9.2 1.9.4 2.8.6v-27.5h27.5c1.5 0 2.9.6 3.8 1.7 1 1.1 1.4 2.6 1.2 4-.1 1.2-.4 2.4-.7 3.5l-1.2 4.5c-.8 3-.2 6.2 1.7 8.7 3.8 5 12.1 5 15.9 0 1.9-2.5 2.5-5.7 1.7-8.7l-1.2-4.5c-.3-1.2-.5-2.3-.7-3.5-.2-1.5.3-2.9 1.2-4 1-1.1 2.4-1.7 3.8-1.7h21c3.5 0 6.4 2.9 6.4 6.4v26.9h-5.1v-26.9c0-.7-.6-1.3-1.3-1.3h-21c.1 1 .3 1.9.5 2.9l1.2 4.5c1.2 4.6.3 9.3-2.6 13.1s-7.2 5.9-12 5.9-9.1-2.2-12-5.9c-2.9-3.8-3.8-8.5-2.6-13.1l1.2-4.5c.2-.9.4-1.9.6-2.8H82.3v22.3c0 1.5-.6 2.9-1.7 3.8-1.1 1-2.6 1.4-4 1.2-1.2-.1-2.4-.4-3.5-.7l-4.5-1.2c-3-.8-6.2-.2-8.7 1.7s-3.9 4.8-3.9 7.9 1.4 6 3.9 7.9 5.7 2.5 8.7 1.7l4.5-1.2c1.2-.3 2.3-.5 3.5-.7 1.4-.2 2.9.3 4 1.2 1.1 1 1.7 2.4 1.7 3.8v22.4h64.9c3 0 5.5-2.4 5.5-5.5v-22.8h5.1v22.8c0 5.8-4.7 10.5-10.5 10.5Z",
    style: {
      strokeWidth: 0,
      fill: "url(#library_puzzle_svg2__d)"
    }
  }));
};
export default SvgLibraryPuzzle;